<template>
    <div class="row justify-content-sm-center">
        <div class="col-sm-6">
            <form class="shaded" @submit.prevent.stop="processForm" novalidate>
                <div class="form-group mb-2">
                    <label class="full">
                        Your name<span class="brand ml-1">*</span>
                        <input v-model="form.name" type="text" placeholder="Please add your name">
                    </label>

                    <div v-if="$v.form.name.$invalid" class="error">
                        <span v-if="!$v.form.name.required">Your name is required.</span>
                        <span v-if="!$v.form.name.minLength">Your name must have at least 4 characters.</span>
                    </div>
                </div>

                <div class="form-group mb-2">
                    <label class="full">
                        Email<span class="brand ml-1">*</span>
                        <input type="email" v-model="form.email" placeholder="Your email">
                    </label>

                    <div v-if="$v.form.email.$invalid" class="error">
                        <span v-if="!$v.form.email.required">Email is required.</span>
                        <span v-if="!$v.form.email.email">Must be a valid email.</span>
                    </div>
                </div>

                <div class="form-group mb-2">
                    <label class="full">
                        Password<span class="brand ml-1">*</span>
                        <input type="password" v-model="form.password" placeholder="Your password">
                    </label>

                    <div v-if="$v.form.password.$invalid" class="error">
                        <span v-if="!$v.form.password.required">Please type a password.</span>
                        <span v-if="!$v.form.password.minLength">Minimum length of 6 characters.</span>
                    </div>
                </div>

                <div class="fs-smaller mt-5 mb-1">
                    <checkbox class="d-inline" name="terms" value="true" v-model="form.hasAcceptTermsConditions"></checkbox>
                    I accept the

                    <span class="darker underlined pointer" @click="openConditions">Terms of Service and Privacy Policy</span>
                </div>

                <input type="submit" class="btn blue widest full" value="Sign up free" :disabled="$v.$invalid">
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'

import extendedVSelect from '@/extends/vue-select'
import Modal from '../../../tools/modal/Modal'

export default {
    created() {
        this.eventHub.$emit('sidebar', 'signup');
        this.eventHub.$emit('topLink', 'login');

        // If we com from 'back button', fill the form | else start from scratch
        if (this.accountSetup.email !== undefined && this.accountSetup.email) {
            this.form = this.accountSetup;
        } else {
            // Commented to prevent wiping when coming back on signup process
            this.resetAccountSetup('agent');
            this.form = this.accountSetup;
        }
    },
    data() {
        return {
            step: 1,
            form: {
                email: '',
                password: '',
                hasAcceptTermsConditions: false
            },
        }
    },
    validations: {
        form: {
            name: {
                required,
                minLength: minLength(4)
            },
            email: {
                required,
                email,
            },
            password: {
                required,
                minLength: minLength(6)
            },
            hasAcceptTermsConditions: {
                required
            }
        },
    },
    computed: {
        ...mapGetters(['accountSetup'])
    },
    methods: {
        ...mapActions([
            'resetAccountSetup',
            'updateAccountSetup',
            'openModal'
        ]),
        processForm() {
            if (!this.$v.form.$error) {
                this.form.step = this.step + 1;

                // Update account setup data
                this.updateAccountSetup(this.form);

                // Move on to step 2
                this.$router.push({ name: 'auth.signup.agent.create' });
            }
        },
        openConditions() {
            window.open('https://pluralo.com/terms-and-conditions/for-agents/', '_blank');
        },
    },
    components: {
        vSelect: extendedVSelect,
        Modal,
    }
}
</script>

<style lang="scss" scoped>
    .form-group {
        min-height: 4.75rem;
    }
</style>



// WEBPACK FOOTER //
// Step1.vue?50f635a8